// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4c07b4ef","61":"b1fd137f","114":"649932be","322":"044be153","502":"b9850a07","641":"7ae45458","654":"a483a692","726":"4edd2d95","942":"ce0eb7ad"}[chunkId] + ".chunk.js";
};